import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { UrlHelper } from '@/utils/UrlHelper';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { useUsersFilter } from '@/features/superAdmin/features/users/hooks/useUsersFilter';
import { UserListResponseDto } from '@/features/superAdmin/features/users/types/superAdmin-users-dto';

type Props = {
    search?: string;
} & ApiHookProps;

export const useUsersListApi = ({searchText}: Props = {}) => {
    const axiosInstance = useAxiosAuth();
    const { filter } = useUsersFilter();
    const { take, skip, orderBy, orderDirection, tenantId } = filter;

    const {
        data: usersListData, 
        isLoading: isLoadingUsersListData, 
        isError: isErrorUsersListData
    } = useQuery({
        queryKey: [
            ApiConfig.queries.superAdmin.users.queryKeys.list, 
            searchText, take, skip, orderBy, orderDirection, tenantId
        ],
        queryFn: async (): Promise<UserListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.superAdmin.users.endpoints.list, {
                searchText, take, skip, orderBy, orderDirection,
                ...(tenantId ? { tenantId } : {}),
            });
            const response = await axiosInstance.get<UserListResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData
    });

    return {
        usersListData,
        isLoadingUsersListData,
        isErrorUsersListData,   
    }
}